<template>
<div v-if="token.role === 'ADM'">
  <div class="row mt-5">
    <div class="col text-center">
      <h5>Empresas</h5>
    </div>
  </div>
  <hr>
  <div class="row">
    <div class="col">
      <form v-on:submit.prevent="save">
        <div class="form-group">
          <label for="empresa">Plano</label>
          <select class="form-control" name="planos" id="planos" v-model="form.plano">
            <option v-for="plano in planos" :key="plano._id" :value="plano._id">{{plano.nome}}</option>
          </select>

          <div class="checkbox" v-if="form._id">
            <label>
              <input v-model="form.renovar" type="checkbox"> Renovar Plano
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox" v-for="(modulo, index) in modulos" :key="index">
            <label>
              <input v-model="form.modulos[modulo.alias]" type="checkbox">{{modulo.nome}}
            </label>
          </div>
        </div>

        <div class="form-group">
          <label for="documento">Nome</label>
          <input
            type="text"
            class="form-control"
            v-model="form.nome"
            id="nome"
            placeholder="Nome ou Razão social"
          />
        </div>

        <div class="form-group">
          <label for="expiraEm">Plano expira em (para alterar data de expiração marque renovar o plano):</label>
          <input
            type="text"
            class="form-control"
            v-model="form.expiraEm"
            id="expiraEm"
            disabled
          />
        </div>

        <div class="form-group">
          <label for="doc">Logo</label>
          <vue-dropzone ref="doc" id="doc" :options="dropzoneOptions" v-on:vdropzone-success="updateDoc"></vue-dropzone>
        </div>

        <div class="form-group mt-2">
          <button class="btn btn-primary btn-raised btn-block">Salvar</button>
          <router-link :to="route" class="btn btn-danger btn-raised btn-block">Cancelar</router-link>
        </div>nome
      </form>
    </div>
  </div>
</div>
</template>

<script>
import ls from 'local-storage';
import moment from 'moment';
import vueDropzone from 'vue2-dropzone';

export default {
  components: {
    vueDropzone
  },
  data() {
    return {
      modulos: [
        {
          nome: 'Módulo Renovação',
          alias: 'renovacao'
        },
        {
          nome: 'Gráficos Condicionantes',
          alias: 'condicionantes'
        },
        {
          nome: 'Módulo Compromissos',
          alias: 'compromissos'
        },
        {
          nome: 'Módulo Resíduos',
          alias: 'residuos'
        },
        {
          nome: 'Cliente não cadastra e nem atualiza licenças',
          alias: 'coNAOcadastra'
        }
      ],
      form: {
        plano: '',
        nome: '',
        mimetype: '',
        filename: '',
        originalname: '',
        expiraEm: '',
        renovar: false,
        modulos: {
        }
      },
      planos: [],
      dropzoneOptions: this.$http.getDropzoneConfig(
        `/admin/empresas/upload`,
        'post',
        {
          maxFiles: 1,
          addRemoveLinks: true,
          capture: true,
          dictDefaultMessage: 'Clique ou arraste arquivos aqui para UPLOAD',
          dictRemoveFile: 'Remover'
        }
      ),
      route: '/admin/empresas'
    };
  },
  methods: {
    save() {
      const method = this.$route.params.id ? this.$http.put : this.$http.post;

      method(this.route, this.form).then(response => {
        if (response.data.success) {
          this.$toasted.show('Cadastrado com sucesso!', this.$custom.success);
          this.$router.push(this.route);
        } else {
          this.$toasted.show('Ocorreu um erro!', this.$custom.error);
        }
      });
    },
    updateDoc(file, response) {
      this.form.mimetype = response.mimetype;
      this.form.filename = response.filename;
      this.form.originalname = response.originalname;
    }
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.$http
        .get(`${this.route}/${this.$route.params.id}`)
        .then(response => {
          if (response.data) {
            this.form = response.data;

            if (this.form.expiraEm) {
              this.form.expiraEm = moment(this.form.expiraEm).format('DD/MM/YYYY HH:mm:ss');
            }
          }

        });
    }

    if (this.token.role === 'ADM') {
      this.$http.post(`admin/planos/listAll`).then(response => {
        if (response.data) this.planos = response.data;
      });
    }
  }
};
</script>
<style>
.vue-dropzone .dz-preview .dz-details {
  background-color: #0a823b;
}
</style>



// WEBPACK FOOTER //
// src/components/app/admin/empresas/Form.vue